import { useEffect, useMemo } from 'react';

function base64ToBytes(b64: string): Uint8Array {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/**
 * Object URL for a base64 CSV, revoked when the value changes or the caller
 * unmounts. Returns null rather than throwing on malformed base64 — a broken
 * attachment should cost the download link, not the whole preview.
 */
export function useCsvObjectUrl(csvBase64: string | null | undefined): string | null {
  const url = useMemo(() => {
    if (!csvBase64) return null;
    try {
      const bytes = base64ToBytes(csvBase64);
      const blob = new Blob([bytes as BlobPart], { type: 'text/csv;charset=utf-8' });
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  }, [csvBase64]);

  useEffect(() => () => {
    if (url) URL.revokeObjectURL(url);
  }, [url]);

  return url;
}
